const state = {
  screenAuthority: [],
  screenOperationAuthority: []
};

const getters = {
  screenAuthority: state => state.screenAuthority,
  screenOperationAuthority: state => state.screenOperationAuthority
};

const mutations = {
  setScreenAuthority(state, screenAuthority) {
    state.screenAuthority = screenAuthority;
  },
  setScreenOperationAuthority(state, screenAuthority) {
    state.screenOperationAuthority = screenAuthority;
  },
  clearScreenAuthority(state) {
    state.screenAuthority = [];
    state.screenOperationAuthority = [];
  }
};

const actions = {
  setScreenAuthority(context, screenAuthority) {
    context.commit("setScreenAuthority", screenAuthority);
  },
  setScreenOperationAuthority(context, screenAuthority) {
    context.commit("setScreenOperationAuthority", screenAuthority);
  },
  clearScreenAuthority(context) {
    context.commit("clearScreenAuthority");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
